import React from "react";
import "./Layout.css";
import headerToggle from "../assets/images/header-toggle.png";
import { Navbar, Nav, Container, NavDropdown, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useNavbarContent } from '../hooks/useNavbarContent';
import { useDynamicStyles } from '../hooks/useDynamicStyles';
import fallbackLogo from '../assets/images/logo.png';
import GoogleTranslate from '../components/GoogleTranslate';
import mobilelanguageIcon from '../assets/images/mobile-lang.png';
import NotificationIcon from '../assets/images/bellicon.png';
//Import SVg
import { LanguageMobileIcon , SearchBarIcon } from '../components/SvgIcons';


const Header = ({ toggleSidebar, isSidebarOpen }) => {
    const { data: navbarData, isLoading } = useNavbarContent();
    


  return (
    <header className={`headerDash ${isSidebarOpen ? "shifted" : ""}`}>
      <div className="dash-main-heading">
        <div className="head-left d-flex">
      <button className="toggle-btn" onClick={toggleSidebar}>
        <img src={headerToggle} alt="" />
      </button>

      <div className="brand text-purple fw-bold">
        VIDYAKASAM EDUCATION
        <div className="sub-text">Change Exam Category</div>
      </div>
      </div>
  <div className="head-right">
            <Nav className="ms-auto align-items-center headerNavigation d-none d-lg-flex">
              <Nav.Link href="#">Home</Nav.Link>
              <Nav.Link href="#">Features</Nav.Link>
              <Nav.Link href="#">About Us</Nav.Link>
              <NavDropdown title="Pages" id="pages-dropdown" menuVariant="light">
                <NavDropdown.Item href="#">Pages</NavDropdown.Item>
              </NavDropdown>
              <Nav.Link href="#">Pricing</Nav.Link>
              <NavDropdown title="Blog" id="blog-dropdown" menuVariant="light">
                <NavDropdown.Item href="#">Blog List</NavDropdown.Item>
                <NavDropdown.Item href="#">Single Blog</NavDropdown.Item>
              </NavDropdown>
              <Nav.Link href="#">Contact</Nav.Link>
              <Button className="get-started ms-lg-3 fw-bold btn-purple">Get Started</Button>
            </Nav>
              {/* Dashboard Sub Header */}
       
       <div className="dashboard-subheading d-flex justify-content-right">

          {/* Search Bar */}
           <div className="search-box1 d-none d-lg-flex">
                <input
                  type="text"
                  placeholder="Search here"
                  className=""
                />
                <i className="fa fa-search"></i>
              </div>
          {/* Search Bar */}

          {/* Mobile Search Bar */}
         <div className="d-flex d-lg-none">
           <SearchBarIcon/>
           </div>
          {/* Mobile Search Bar */}


          {/* Mobile Language Section */}
             <div className="languageImg  d-flex d-lg-none">
               <LanguageMobileIcon/>
             </div>

              {/*Web Language Section */}
             <div className="nav-item nav-lang dropdown dashboard-language d-none d-lg-flex">
              <a
                className="nav-link language-dropdown text-black fw-bold d-flex align-items-center d-none d-md-flex"
                href="#"
                id="LanguageDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="nav-profile-img me-2">
                <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6719 0.000244141V14.6514L20.1771 17.633C20.2666 17.6604 20.3568 17.6743 20.4468 17.6743C20.9437 17.6743 21.3468 17.2712 21.3468 16.7743V4.00961C21.3468 3.61719 21.0919 3.27006 20.7179 3.15139L10.6719 0.000244141ZM11.5719 13.9901V1.22511L20.4468 4.00961L20.4451 16.7738L11.5719 13.9901Z" className="checkSVG"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.674 0V14.6511L1.17 17.6328C1.0818 17.6607 0.9918 17.6742 0.9 17.6742C0.4032 17.6742 0 17.2719 0 16.7742V4.0095C0 3.6162 0.2556 3.2679 0.63 3.1509L10.674 0ZM7.974 5.4L4.374 6.4062V12.6L7.974 11.5938V10.6407L5.4027 11.4075V9.5022L7.974 8.7354V7.7823L6.6888 8.1396L5.4027 8.5491V7.1199L7.974 6.3531V5.4Z" className="checkSVG"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4259 9.70915L16.4246 9.66846L16.7707 9.84223L16.9248 9.92568C16.9455 9.93783 16.9643 9.94939 16.9819 9.96083L17.0612 10.0169C17.1138 10.0572 17.1467 10.086 17.2877 10.2128L17.2546 12.1662L17.3298 12.263L17.94 12.4187L18.0648 12.3219L18.0643 7.51195L18.2044 7.52958L18.6584 7.60983L18.7758 7.51135V6.92995L18.6917 6.83123L16.5092 6.47933L16.3933 6.57805V7.17025L16.4757 7.26869L17.2543 7.40695V9.38295L17.1359 9.32883C17.0944 9.30886 16.8209 9.17141 16.7077 9.11685L16.2567 8.90565L16.1457 8.84883C16.1127 8.83096 16.0807 8.81262 16.0484 8.79298L15.9607 8.71835C15.8992 8.6711 15.8321 8.62916 15.7622 8.59429L15.7093 8.57095L15.7672 8.52686C16.0163 8.30654 16.1928 7.94849 16.1928 7.55095C16.1928 6.7672 15.6351 6.19995 14.7995 6.19995C14.2807 6.19995 13.8397 6.42458 13.5795 6.77797L13.5912 6.90978L14.016 7.31298L14.1676 7.2966C14.3094 7.0877 14.5079 6.97145 14.7842 6.97145C15.1571 6.97145 15.3826 7.20707 15.3826 7.59325C15.3826 8.03444 15.0977 8.30775 14.6474 8.30775H14.3981L14.2981 8.40775V8.97115L14.3981 9.07115H14.8319C15.3454 9.07115 15.6157 9.30219 15.6157 9.71815C15.6157 10.1728 15.3248 10.475 14.8157 10.475C14.423 10.475 14.1052 10.291 13.8652 9.99852L13.7156 9.99282L13.298 10.4293L13.2969 10.5664C13.6676 10.9669 14.1911 11.2375 14.8157 11.2375C15.7717 11.2375 16.4259 10.5929 16.4259 9.70915Z" className="checkSVG"/>
                  </svg>
                
                </div>
                <div className="nav-language-text d-flex align-items-center">
                  <p className="mb-0 me-2">
                    <span className="for-desktop text-purple" style={{ fontSize: '12px'}}>ENGLISH</span>
                  </p>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
                      <path
                        d="M-8.7829e-07 0.862298C0.0144006 1.12229 0.123202 1.3675 0.305223 1.55018L5.33348 6.66834C5.76723 7.11055 6.23311 7.11055 6.66686 6.66834C8.3483 4.96502 10.0217 3.25896 11.6871 1.55018C12.0887 1.14072 12.0967 0.641191 11.7513 0.272683C11.4059 -0.0958244 10.8838 -0.0958239 10.4742 0.321818C9.06585 1.74126 7.66823 3.16888 6.2813 4.6047C6.0564 4.82581 5.94394 4.83399 5.72707 4.6047C4.33747 3.16343 2.93181 1.74672 1.53418 0.321819C1.25305 0.035202 0.923715 -0.0876345 0.546193 0.0679578C0.168673 0.22355 0.0401602 0.49379 -8.7829e-07 0.862298Z"
                      className="arrowSVG"
                      />
                    </svg>
                  </span>
                </div>
              </a>

{/* Mobile view Language */}

      <ul className="dropdown-menu dropdown-menu-end navbar-dropdown dropdown-lang" aria-labelledby="LanguageDropdown">
        {[
          { name: 'English', id: 'EN' },
          { name: 'Hindi', id: 'HI' },
          { name: 'Marathi', id: 'MR' },
          { name: 'Gujarati', id: 'GJ' },
          { name: 'Bengali', id: 'BN' },
        ].map((lang, index) => (
          <React.Fragment key={lang.id}>
            <li>
              <a className="dropdown-item" href="#" data-short-name={lang.id}>
                <i className="mdi mdi-cached me-2 text-success"></i>
                {lang.name}
              </a>
            </li>
            {index < 4 && <li><hr className="dropdown-divider" /></li>}
          </React.Fragment>
        ))}
      </ul>
    </div>
     {/* Language Section */}

     {/* Notification Section */}
      <div className="bell">
        <span className="bell-icon">  <img src={NotificationIcon}/> </span>
        <span className="badge">4</span>
      </div>
     {/* Notification Section */}
       </div>
       </div>
       </div>

       {/* Dashboard Sub Header */}
  
    </header>
  );
};

export default Header;

